var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (!_vm.loading)?_c(_vm.intakeComponent,{tag:"component"}):_c('main-loader')}
var staticRenderFns = []

export { render, staticRenderFns }